var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusIconLarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 22.4,
    height: 22.4,
    viewBox: "0 0 22.4 22.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3165",
    "data-name": "Rectangle 3165",
    width: 22.4,
    height: 22.4,
    transform: "translate(0 0)",
    fill: "#2e71fc"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "plusIconLarge"
  }, /*#__PURE__*/React.createElement("path", {
    id: "plus-round",
    d: "M18.136,10.4H12.96V5.224a1.281,1.281,0,0,0-2.56,0V10.4H5.224a1.281,1.281,0,0,0,0,2.56H10.4v5.176a1.281,1.281,0,0,0,2.56,0V12.96h5.176a1.281,1.281,0,0,0,0-2.56Z",
    transform: "translate(-0.48 -0.48)",
    fill: "#2e71fc"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIconLarge);
export default __webpack_public_path__ + "static/media/plusIconLarge.935ddb1611588d841d66136a9143836c.svg";
export { ForwardRef as ReactComponent };